<template>
  <div id="app">
    <router-view :profile="profile" :user="user" v-if="logged_in != undefined && ((logged_in && profile && profile.team && profile.team.name && profile.team_role && profile.team_role.role && profile.avatar && profile.avatar.name) || (!logged_in)) || $route.name === 'logout'"/>
    <Loading v-else />
  </div>
</template>

<script>
// eslint-disable-next-line
import { db, auth, analytics } from '@/main.js'
import { version } from "../package.json"
import parse_name from 'parse-full-name'

function isPWA() {
  return window && window.matchMedia("(display-mode: standalone)").matches;
}

export default {
  name: 'App',
  data () {
    return {
      logged_in: undefined,
      profile: undefined,
      user: undefined,
    }
  },
  metaInfo: {
    name: 'Vidon',
    title: 'Vidon.ai',
    titleTemplate: '%s | Vidon',
    meta: [
      {charset: 'utf-8'},
      {'http-equiv': 'X-UA-Compatible', content: 'IE=edge'},
      {name: 'viewport', content: 'width=device-width, initial-scale=1'}
    ],
  },
  created () {
    auth.onAuthStateChanged((user) => {
      if (user) {
        this.user = user
        this.logged_in = true
        this.$bind('profile', db.collection('user').doc(user.uid))

        let name = parse_name.parseFullName(user.displayName)

        let latest_recording
        try {
          // eslint-disable-next-line
          latest_recording = FS.getCurrentSessionURL()
        } catch(err) {
          // pass
        }

        if (this.$route.name === 'logout') {
          return
        }

        analytics.identify(user.email, {email: user.email, firstName: name.first, lastName: name.last, name: user.displayName, latest_recording: latest_recording})

        if (this.$route.name !== 'video_player' && location.hostname.indexOf('vidon.video') > -1) {
          location.replace("https://app.vidon.ai")
          return
        }

        if (window.HubSpotConversations && window.HubSpotConversations.widget) {
          window.HubSpotConversations.widget.refresh()
        }

        if (this.$route.name === 'home' || this.$route.name === 'login' || this.$route.name === 'login_signup' || this.$route.name === 'login_router' || this.$route.name === 'login_login' || this.$route.name === 'login_demo') {
          this.$router.push({name: 'onboarding_welcome'})
        }

      } else {
        this.user = {}
        this.logged_in = false
        try {
          this.$unbind('profile')
        } catch(err) {
          // pass
        }

        if ((this.$route.name !== 'video_hosting' && this.$route.name !== 'video_player') && location.hostname.indexOf('vidon.video') > -1) {
          this.$router.push({name: 'video_hosting'})
          return
        }

        if (this.$route.name !== 'home' && this.$route.name !== 'video_player' && this.$route.name !== 'login_demo' && this.$route.name !== 'login_signup' && this.$route.name !== 'login_login' && this.$route.name !== 'login' && this.$route.name !== 'login_router') {
          this.$router.push({name: 'home'})
        }

        if (this.$route.name === 'home') {
          let email = this.$route.query.email || null
          let plan = this.$route.query.plan || null
          this.$router.push({name: 'login_router', params: {email, plan}})
        }
      }
    })
  },
}

</script>

<style>

.sidebar  {
  padding-left: 250px;
}

.sidebar.collapsed {
  padding-left: 50px;
}

</style>
